import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Image from "gatsby-image"
import Logo from "./NavbarLogo"
import { FaTimes } from "react-icons/fa"

const getImage = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "hero-bg2.png" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 2600) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    tglBtn: file(relativePath: { eq: "toggle-btn.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

  }
`

const Navbar = ({ toggleSidebar, isOpen, children, modal, closeTo }) => {
  const data = useStaticQuery(getImage)
  
  return (
    <>
      <Wrapper openedSide={isOpen}>
        {modal ? (
          <Link to={closeTo}>
            <FaTimes className="close-btn" />
          </Link>
        ) : (
          <>
            <div className="nav-center">
              <div className="nav-header">
                <Logo />

                <div className="buttons">
                  <Link to="#" className="btn btn-main">
                    Hire Us
                  </Link>
                  <button
                    type="button"
                    className="toggle-btn"
                    onClick={toggleSidebar}
                  >
                    <Image
                      fluid={data.tglBtn.childImageSharp.fluid}
                      alt="Menu"
                    />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </Wrapper>
      <BackgroundImage fluid={data.defaultBcg.childImageSharp.fluid}>
      {children}
    </BackgroundImage>
    </>
  )
}

export default Navbar

const Wrapper = styled.nav`
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  background: var(--clr-white);
  box-shadow: var(--light-shadow);
  
  

  .close-btn {
    position: absolute;
    left: 20px;
    top: 20px;
    font-size: 2.5rem;
    background: transparent;
    border-color: transparent;
    color: var(--clr-primary-1);
    cursor: pointer;
  }

  .nav-center {
    width: 90vw;    
    @media screen and (min-width: 568px) {
      width: 85vw;
    }
  }
  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }


  .buttons {
    display: flex;
    
  }
  .btn {
    padding: 0.5rem 3rem;
    margin-right: 3rem;
    display: none;
    border-radius: var(--radius);
    opacity: ${props => (props.openedSide ? 0 : 1)};
  }

  .toggle-btn {
    background: transparent;
    border: transparent;
    cursor: pointer;
    transition: var(--transition);
    width: 24px;
  }
  .toggle-btn:hover {
    background: var(--clr-grey-9);
    border: var(--clr-primary-3);
  }


  /* Iphone 11 pro max */
  @media screen
  and (min-width: 568px) 
  and (orientation: portrait)
  {
    .logo{width: 144px;}
  }
  
  /* iPhone 11 pro max horizontally*/
  @media screen 
  and (min-width: 768px)
  and (orientation: landscape) {
    .logo{width: 144px;}
    .nav-center{width: 80vw;}
  }

  /* iPad mini*/
  @media screen 
  and (min-width: 768px)
  and (orientation: portrait) {
    .nav-center{width: 80vw;}
  }

  @media screen 
  and (min-width: 1024px)
  and (orientation: portrait) {
    .btn {
      display: inherit;
    }
  }

  /* iPad mini horizontally */
  @media screen 
  and (min-width: 1024px) 
  and (orientation: landscape) {
    .btn{display: none;}
  }


  @media screen and (min-width: 1025px) {    
    
    .nav-center {
      width: 90vw;
      margin: 0 auto;
      max-width: 1360px;
      }
    .btn {
      display: inherit;
      font-size: 16px;
      padding: 13px 48px;
    margin-right: 55px;
      }
  }
`
